import { AlertCircleIcon } from "lucide-react";

const EquipmentQuantityNote = () => {
  return (
    <div className="flex items-center gap-3">
      <AlertCircleIcon size={42} strokeWidth={1.5} color="var(--warning)" />

      <p className="text-sm">
        O Estabelecimento poderá visualizar a quantidade de equipamentos em cada categoria da sua frota.
      </p>
    </div>
  );
};

export default EquipmentQuantityNote;
